import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map } from 'rxjs/operators';
import { invitesActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of, switchMap } from 'rxjs';
import { InvitesService } from '../../services/invites.service';

@Injectable({
  providedIn: 'root',
})
export class InvitesEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private invitesService: InvitesService,
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invitesActions.findAll),
      switchMap(() => {
        return this.invitesService.findAll().pipe(
          map((response) =>
            invitesActions.findAllSuccess({ invites: response.data }),
          ),
          catchError((error: ApiError) =>
            of(invitesActions.findAllError({ error: error.message })),
          ),
        );
      }),
    ),
  );
}
